module.exports = __webpack_public_path__ + "img/1493126688.51d868c4.jpg";